<template>
  <div>
    <b-skeleton-wrapper :loading="espLoader">
      <template #loading>
        <b-skeleton
          type="button"
          width="100%"
          class="mb-75"
        />
      </template>
      <div class="mb-75">
        <v-select
          id="esp"
          placeholder="Clic aqui para seleccionar"
          label="nombre"
          :value="esp"
          :options="tiposEsp"
          :clearable="true"
          @input="(val) => $emit('tipoEsp', val)"
        />
      </div>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import {
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, watch, onMounted } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'

export default {
  components: {
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
  },
  props: {
    esp: {
      type: [Object, null],
      default: null,
    },
    mat: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props, { emit }) {
    const tiposEsp = ref([])
    const toast = useToast()
    const espLoader = ref(false)
    const loadtiposEsp = () => {
      espLoader.value = true
      getData({ action: 3, token: store.state.cuenta.session.token, data: props.mat }, 'wsbajas')
        .then(response => {
          espLoader.value = false
          if (response.status === 200) {
            tiposEsp.value = response.data.data || []
            emit('catalogotiposEsp', tiposEsp.value)
            if (tiposEsp.value.length >= 1) { emit('tipoEsp', tiposEsp.value[0]) } else { emit('tipoEsp', null) }
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando especialidades',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          espLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando especialidades',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    onMounted(() => {
      loadtiposEsp()
    })
    // eslint-disable-next-line no-unused-vars
    watch(() => props.mat, value => {
      tiposEsp.value = []
      emit('catalogotiposEsp', tiposEsp.value)
      emit('tipoEsp', null)
      loadtiposEsp()
    })
    return {
      tiposEsp,
      espLoader,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
